import type { Zero } from '@rocicorp/zero'

import type { schema } from '#zero/queries.ts'
import type { ZeroQueryContext } from '#zero/zero-default-types.ts'

type AppZero = Zero<typeof schema, undefined, ZeroQueryContext | undefined>

/**
 * The app's Zero client, captured via `ZeroProvider`'s `init` callback so
 * non-React code (route loaders) can preload queries. See `AppZeroProvider`.
 */
let appZero: AppZero | undefined

export function setAppZero(zero: AppZero) {
  appZero = zero
}

export function getAppZero(): AppZero | undefined {
  return appZero?.closed ? undefined : appZero
}
